// Single source of truth for a matrix column's answer type.
//
// Questionnaire matrix columns predate this property and carry no Type — they
// are pick-one (radio) columns, so an absent or unknown Type reads as 'choice'.
// That keeps the new intake-form column typing purely additive.
const COLUMN_TYPES = ["number", "text", "choice"];

const getColumnType = (column) =>
    COLUMN_TYPES.includes(column?.Type) ? column.Type : "choice";

export default getColumnType;
